(function () {
  const el = window.UIDOM.el;
  const esc = window.UIDOM.esc;
  const TAB_KEY = "riftbound-trainer-tab";
  const TABS = [["reviews", "Reviews"], ["lab", "Lab"]];

  const S = {
    tab: "reviews",
    reviews: null,
    err: null,
  };

  function reviewsPanel() {
    const panel = el("div", "trpanel");
    RB.TrainerReview.render(panel);
    return panel;
  }

  function labPanel() {
    const panel = el("div", "trpanel");
    RB.TrainerLab.render(panel);
    return panel;
  }

  function fetchJson(url, cb) {
    RB.Api.get(url, true).then(cb).catch(function (e) {
      S.err = "Could not load " + url + ": " + e.message;
      render();
    });
  }

  function render() {
    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    const shell = window.UIX.screenShell("trainerscreen", "TRAINER", "Reviews · lab");
    const wrap = shell.wrap;
    const local = el("button", "btn ghost", "Play");
    local.onclick = function () { location.href = "/play"; };
    shell.acts.appendChild(local);

    if (S.err) wrap.appendChild(el("div", "menuerr", "⚠ " + esc(S.err)));

    const pane = el("div", "mspane msbev");
    const inner = el("div", "mspanein msbev");
    inner.style.padding = "18px";
    const tabs = el("div", "trtabs");
    for (const t of TABS) {
      (function (t) {
        const b = el("button", S.tab === t[0] ? "btn on" : "btn", t[1]);
        b.onclick = function () {
          S.tab = t[0];
          S.err = null;
          try { localStorage.setItem(TAB_KEY, t[0]); } catch (e) { }
          render();
        };
        tabs.appendChild(b);
      })(t);
    }
    inner.appendChild(tabs);
    inner.appendChild(S.tab === "lab" ? labPanel() : reviewsPanel());
    pane.appendChild(inner);
    wrap.appendChild(pane);
    root.appendChild(wrap);
  }

  window.RB.Trainer = {
    boot() {
      try { S.tab = TABS.some(function (t) { return t[0] === localStorage.getItem(TAB_KEY); }) ? localStorage.getItem(TAB_KEY) : "reviews"; } catch (e) { }
      const hash = (location.hash || "").replace("#", "");
      if (TABS.some(function (t) { return t[0] === hash; })) S.tab = hash;
      render();
      fetchJson("/api/trainer/reviews", function (j) { S.reviews = Array.isArray(j) ? j : []; render(); });
    },
  };
})();
